import { useState } from "react";
import { useMutation } from '@tanstack/react-query'
import Axios from "Services/Auth/AxiosInterceptors";
import { InputField } from "Components/Common/InputField/InputField";
import { Button } from "Components/Common/Button/Button";
import { ErrorPopUp } from "Components/Common/PopUp/PopUp";
import "Colors.css";

const SUB_HEADING_CSS = "mt-4 text-sm leading-4 font-medium sapphire";
const TITLE_CSS = "light_grayish_navy text-left font-medium"

function PasswordReset() {
  const [email, setEmail] = useState('');
  const [copied, setCopied] = useState(false);

  const {
    data,
    error,
    mutate,
    isLoading,
    isSuccess,
    isError,
  } = useMutation({
    mutationFn: () => Axios.post('/user/user/admin-reset-password', { email }),
  })

  const result = data?.data?.result
  const apiError = error?.response?.data?.errors?.[0] || 'Could not reset the password'

  const copyPassword = () => {
    navigator.clipboard.writeText(result?.password).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="p-4 flex flex-wrap gap-4 justify-between" style={{ width: '350px', display: 'block' }}>
      <div>
        {!isSuccess && !isError && <div className={TITLE_CSS}>Reset a patient's password</div>}

        {isSuccess && (
          <div className="green text-left font-medium">
            Password reset for {result?.email}
          </div>
        )}
        {isError && (
          <div className="text-red-800 text-left font-medium">
            {apiError}
          </div>
        )}

        {isError && <ErrorPopUp error={apiError} setApiError={() => {}} />}

        {isSuccess && result?.password && (
          <div className={SUB_HEADING_CSS}>
            New Password: <span className="select-all font-semibold">{result.password}</span>
            <Button
              className="w-full py-2 mt-2"
              btnText={copied ? "Copied!" : "Copy Password"}
              onClick={copyPassword}
            />
          </div>
        )}

        <div className="lg:space-y-2 2xl:space-y-4 mt-8">
          <InputField
            placeholder="Patient Email"
            isRequired={true}
            value=""
            onChange={(value) => setEmail(value)}
          />
          <Button
            className="w-full py-2"
            btnText="Reset Password"
            isDisabled={!email.trim()}
            isLoading={isLoading}
            onClick={() => mutate()}
          />
        </div>
      </div>

      <div className="mt-12 p-4 light_grayish_navy text-left" style={{ borderRadius: '10px', background: '#eee', fontSize: '14px' }}>
        Tip: Use this when a patient isn't receiving the forgot-password code. It sets a new permanent password immediately — their old password stops working. Share the new password with the patient and advise them to change it after logging in.
      </div>

    </div>
  );

}

export default PasswordReset
